import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`

export const BottomBlock = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 33px;
    box-sizing: border-box;
`
export const AnaloguesSpanCount = styled.span``
export const AnaloguesButtonContainer = styled.div`
    max-width: 9.1rem;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    margin-right: 0.2rem;
    font-size: 1rem;

    & button {
        padding: 2px 8px;
        font-size: 1rem;
    }

    @media (max-width: 370px) {
        ${AnaloguesSpanCount} {
            display: none;
        }
    }
`
